import { render, staticRenderFns } from "./FtpFileDetailTable.vue?vue&type=template&id=321b3947&scoped=true&"
import script from "./FtpFileDetailTable.vue?vue&type=script&lang=js&"
export * from "./FtpFileDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b3947",
  null
  
)

export default component.exports